import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { LineBoxContainer } from "../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../Button/CalendarLineBtn";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LineBtn from "../../Button/LineBtn";
import FilterIcon from "../../DefaultStyles/FilterIcon";
import Flex from "../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../Filters/DropDown";
import CalendarModal from "../../Modal/CalendarModal";
import ToolTip from "../../Modal/ToolTip";
import {
  CalendarLine,
  HelpIcon,
} from "../Party/ChatInfo/ChatSearch/RecentChat";
import { getAdminAlimtalkAllTemplate } from "../../../AdminApi/commFunc";

interface AlimTalkFilterProps {
  setFilter: any;
  setPage: Dispatch<SetStateAction<number>>;
}

export const templateOptionList = getAdminAlimtalkAllTemplate();

export default function AlimTalkFilter({
  setFilter,
  setPage,
}: AlimTalkFilterProps) {
  const [templateDropDownValue, setTemplateDropDownValue] =
    useState<OptionType>({
      value: "",
      label: "템플릿 선택",
    });
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <SectionFilterContainer>
      <SpaceBetween>
        <Flex gapSize={10}>
          <FilterIcon />

          <DropDown
            isDisabled={false}
            setDropDownValue={setTemplateDropDownValue}
            dropdownValue={templateDropDownValue}
            boxWidth={180}
            optionList={templateOptionList}
          />

          <div />
        </Flex>

        <Flex gapSize={10}>
          <div />

          <ToolTip direction="top" msg="한번에 최대 7일까지 조회 가능" />

          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setStartDateClick(true)}
              value={startDate}
              initValue={"날짜 선택"}
              minWidth={155}
            />

            {startDateClick && (
              <CalendarModal
                closeEvent={() => setStartDateClick(false)}
                changeEvent={(date: string) => setStartDate(date)}
                isFutureDisable={true}
              />
            )}
          </LineBoxContainer>

          <CalendarLine />

          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setEndDateClick(true)}
              value={endDate}
              initValue={"날짜 선택"}
              minWidth={155}
              disabled={startDate === "날짜 선택"}
            />

            {endDateClick && (
              <CalendarModal
                closeEvent={() => setEndDateClick(false)}
                changeEvent={(date: string) => setEndDate(date)}
                dateValue={startDate}
                isAfter={{
                  value: 7,
                  unit: "day",
                }}
              />
            )}
          </LineBoxContainer>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            btnClickEvent={() => {
              setPage(0);
              setFilter({
                click: true,
                template:
                  templateDropDownValue?.value !== ""
                    ? templateDropDownValue?.value!
                    : "",
                startDate: startDate !== "날짜 선택" ? startDate : "",
                endDate: endDate !== "날짜 선택" ? endDate : "",
              });
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            btnClickEvent={() => {
              setTemplateDropDownValue({
                label: "템플릿 선택",
                value: "",
              });

              setStartDate("날짜 선택");
              setEndDate("날짜 선택");
              setFilter({
                click: false,
                template: "",
                startDate: "",
                endDate: "",
              });
            }}
          />
        </Flex>
      </SpaceBetween>
    </SectionFilterContainer>
  );
}

export const SectionFilterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;

  @media screen and (max-width: 1150px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1150px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    column-gap: 10px;
  }
`;

export const SHelpIcon = styled(HelpIcon)`
  margin-left: 20px;

  @media screen and (max-width: 1150px) {
    margin-left: 0px;
    display: none;
  }
`;
